import isColorLight from './isColorLight';

const detectTheme = (bgColor, fgColor) => {

  return isColorLight(bgColor) && !isColorLight(fgColor);
}

export default detectTheme;
